import React, { Component } from 'react'
import { connect } from 'react-redux'
import {
} from '../../redux/actions'

import Support from '../../components/support'

class SupportPage extends Component {

  render() {

    const {
      translate
    } = this.props

    return (
      <Support translate={translate}/>
    )
  }

}

const mapDispatchToProps = (dispatch, props) => ({
})

const mapStateToProps = (state) => ({
  ...state,
})

export default connect(mapStateToProps, mapDispatchToProps)(SupportPage)
